export default {
    setOfferAsChecked(offer) {
        return offer.checked = !offer.checked;
    }
}